<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        A solution is prepared by dissolving
        <number-value :value="sugar" unit="\text{g}" />
        of sucrose in
        <number-value :value="mass" unit="\text{g.}" />
        Answer each of the questions below assuming that the dissolution of sucrose does NOT affect
        the volume of the solution. Note that the molar mass of sucrose is
        <stemble-latex content="$342.3\,\text{g/mol.}$" />
      </p>

      <div v-for="question in questions" :key="question.value">
        <p class="mb-2">
          <stemble-latex :content="question.text" />
        </p>

        <calculation-input
          v-model="inputs[question.value]"
          class="mb-5"
          :prepend-text="question.prependText"
          :append-text="question.appendText"
          :disabled="!allowEditing"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemCPP1220A4Q2',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        inputA: null,
        inputB: null,
        inputC: null,
        inputD: null,
        inputE: null,
        inputF: null,
        inputG: null,
      },
      questions: [
        {
          text: 'a) What is the molality of the sugar solution? ',
          prependText: '$\\text{Molality:}$',
          appendText: '$\\text{m}$',
          value: 'inputA',
        },
        {
          text: 'b) What is the mole fraction of water in the solution?',
          prependText: '$\\text{X}_\\ce{H2O}:$',
          value: 'inputB',
        },
        {
          text: 'c) What is the molarity of the sugar solution at $23.6\\,^\\circ\\text{C}$ where the density of water is $0.9989\\,\\text{g/mL}$?',
          prependText: '$\\ce{Sucrose:}$',
          appendText: '$\\text{M}$',
          value: 'inputC',
        },
        {
          text: 'd) The vapor pressure of pure water at $23.6\\,^\\circ\\text{C}$ is $21.8\\,\\text{mm Hg}$. What is the vapor pressure of the sugar solution at this temperature?',
          prependText: '$\\text{vp:}$',
          appendText: '$\\text{mm Hg}$',
          value: 'inputD',
        },
        {
          text: 'e) The boiling point constant of water is $0.512\\,^\\circ\\text{C}/\\text{m}$. At what temperature does the sugar solution boil?',
          prependText: '$\\text{T:}$',
          appendText: '$^\\circ\\text{C}$',
          value: 'inputE',
        },
        {
          text: 'f) The freezing point of water is $1.86\\,^\\circ\\text{C}/\\text{m}$. At what temperature does the sugar solution freeze?',
          prependText: '$\\text{T:}$',
          appendText: '$^\\circ\\text{C}$',
          value: 'inputF',
        },
        {
          text: 'g) What is the osmotic pressure of the sugar solution at at $25.0\\,^\\circ\\text{C}$?',
          prependText: '$\\Pi:$',
          appendText: '$\\text{atm}$',
          value: 'inputG',
        },
      ],
    };
  },
  computed: {
    sugar() {
      return this.taskState.getValueBySymbol('sugar').content;
    },
    mass() {
      return this.taskState.getValueBySymbol('mass').content;
    },
  },
};
</script>
